import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "onChange", "disabled", "error", "isDark", "darkMode", "label", "className", "wrapperProps", "labelProps", "htmlProps", "inputProps", "children"];
import { forwardRef } from 'react';
import cn from 'classnames';
import transition from "../styles/transition";
import { DISABLED_WRAPPER, INDICATOR, RADIO, WRAPPER } from "./classnames";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Radio = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
    onChangeProp = _ref.onChange,
    disabled = _ref.disabled,
    error = _ref.error,
    isDark = _ref.isDark,
    darkMode = _ref.darkMode,
    label = _ref.label,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    wrapperProps = _ref.wrapperProps,
    _ref$labelProps = _ref.labelProps,
    labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
    htmlProps = _ref.htmlProps,
    inputProps = _ref.inputProps,
    children = _ref.children,
    radioProps = _objectWithoutProperties(_ref, _excluded);
  var type = 'default';
  var typeIndicator = isDark || darkMode ? 'checked-dark' : 'default';
  if (error) {
    type = 'error';
  }
  if (checked) {
    type = isDark || darkMode ? 'checked-dark' : 'checked';
  }
  var labelColorClassName = isDark || darkMode ? 'text-white' : 'text-base-main';
  if (disabled) {
    labelColorClassName = 'text-gray-dark';
  }
  var onChange = function onChange(e) {
    if (onChangeProp) {
      onChangeProp(e);
    }
  };
  return /*#__PURE__*/_jsxs("label", _objectSpread(_objectSpread(_objectSpread({
    className: "".concat(disabled ? DISABLED_WRAPPER : WRAPPER, " ").concat(className)
  }, wrapperProps), htmlProps), {}, {
    children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread(_objectSpread({
      className: "hidden",
      type: "radio",
      disabled: disabled,
      onChange: onChange,
      checked: checked
    }, radioProps), inputProps), {}, {
      ref: ref
    })), /*#__PURE__*/_jsx("div", {
      className: RADIO[type],
      style: {
        transition: transition('border'),
        marginTop: label ? '2px' : undefined
      },
      children: /*#__PURE__*/_jsx("div", {
        className: "".concat(INDICATOR[typeIndicator]).concat(!checked ? ' opacity-0' : ''),
        style: {
          transition: transition('opacity')
        }
      })
    }), label ? /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
      className: cn('font-body3 ml-16', labelColorClassName),
      style: {
        transition: transition('color')
      }
    }, labelProps), {}, {
      children: label
    })) : children]
  }));
});
Radio.displayName = 'Radio';
export default Radio;